import {Menu} from "@bryntum/grid";

// just a simple wrapper to keep columns in gridConfig a LITTLE less cluttered
export default class DotMenuFactoryHelper {
    public static build (record:any, items:Array<object>) {
        const menu = new Menu({
            anchor: true,
            autoShow: true,
            items: items
        });

        //@ts-expect-error
        menu.setRecord(record);

        return menu;
    }
}